'use client'

import { Button, InlineStack } from '@shopify/polaris'
import { useSigmaSurface } from '@/components/SigmaSurfaceProvider'
import {
  REPORTING_DATE_PRESET_LABELS,
  REPORTING_DATE_PRESET_ORDER,
  type ReportingDatePresetId,
} from '@/lib/dashboard/reportingDatePresets'

export function ReportingDatePresetButtons(props: {
  onSelect: (preset: ReportingDatePresetId) => void
  disabled?: boolean
}) {
  const surface = useSigmaSurface()
  const isPortal = surface === 'portal'

  const stack = (
    <InlineStack gap="200" wrap>
      {REPORTING_DATE_PRESET_ORDER.map((id) => (
        <Button
          key={id}
          size="slim"
          variant={isPortal ? 'secondary' : 'plain'}
          disabled={props.disabled}
          onClick={() => props.onSelect(id)}
        >
          {REPORTING_DATE_PRESET_LABELS[id]}
        </Button>
      ))}
    </InlineStack>
  )

  if (isPortal) {
    return <div className="sigma-portal-date-presets">{stack}</div>
  }
  return stack
}
